<ol class="breadcrumb">
  <li class="breadcrumb-item"><a routerLink="/promo-codes">Promo Codes</a></li>
  <li class="breadcrumb-item active fs-block">{{promoCodeForm.get('promo_code').value}}</li>
</ol>

<h1 class="fs-block">Promo Code - {{promoCodeForm.get('promo_code').value}}</h1>

<div class="row">
  <div class="col-sm-10">
    <form class="form-horizontal">
      <div class="form-group">
        <label class="col-sm-3 control-label">Active?</label>
        <div class="col-sm-9">
          <ui-switch id="active" name="active" [(ngModel)]="promoCodeActive" (click)="this.toggleActive()">
          </ui-switch>
        </div>
      </div>
    </form>
    <form class="form-horizontal" [formGroup]="promoCodeForm" >
      <div class="form-group">
        <label class="col-sm-3 control-label">Code</label>
        <div class="col-sm-9">
          <input type="text" class="form-control fs-block" name="code" required
            placeholder="Code" formControlName="promo_code">
          @if (promoCodeForm.get('promo_code').invalid && promoCodeForm.get('promo_code').touched) {
            <div class="form-error">
              <p>Code is required</p>
            </div>
          }
        </div>
      </div>
      <div class="form-group">
        <label for="discount_type" class="col-sm-3 control-label">Discount Type</label>
        <div class="col-sm-9">
          <select class="form-control" formControlName="discount_type">
            <option selected="" disabled="" value="">Discount Type</option>
            @for (type of discountTypes; track type) {
              <option [value]="type.value">
                {{type.title}}
              </option>
            }
          </select>
          @if (promoCodeForm.get('discount_type').invalid && promoCodeForm.get('discount_type').touched) {
            <div class="form-error">
              <p>Promo type is required</p>
            </div>
          }
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-9 col-sm-offset-3">
          <div class="input-group">
            @if (promoCodeForm.get('discount_type').value === 'dollar_amount') {
              <span class="input-group-addon">$</span>
            }
            @if (promoCodeForm.get('discount_type').value) {
              <input type="number" class="form-control"
                placeholder="{{ promoCodeForm.get('discount_type').value === 'percentage_off' ? 'Percentage' : 'Dollars'}}" formControlName="discount">
            }
            @if (promoCodeForm.get('discount_type').value === 'percentage_off') {
              <span class="input-group-addon">%</span>
            }
          </div>
          @if (promoCodeForm.get('discount').invalid &&
            promoCodeForm.get('discount').touched && promoCodeForm.get('discount_type').value === 'dollar_amount') {
            <div class="form-error">
              <p>Amount cannot be negative</p>
            </div>
          }
          @if (promoCodeForm.get('discount').invalid &&
            promoCodeForm.get('discount').touched && promoCodeForm.get('discount_type').value === 'percentage_off') {
            <div class="form-error">
              <p>Percentage should be between 0 and 100</p>
            </div>
          }
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">Description (Optional)</label>
        <div class="col-sm-9">
          <textarea class="form-control" formControlName="description" rows="5" placeholder="For eg. 10% OFF, 5$ OFF etc">
          </textarea>
        </div>
      </div>
    </form>
    <div class="row action-wrap">
      @if (!isEditingPromoCode) {
        <div class="col">
          <button type="button" class="btn btn-primary" (click)="editPromoCode()">Edit</button>
        </div>
      }
      @if (isEditingPromoCode) {
        <div class="col">
          <button type="button" class="btn btn-default" (click)="cancelEditing()">Close</button>
          <button type="button" class="btn btn-primary" [disabled]="promoCodeForm.invalid" (click)="updatePromoCode()">Update</button>
        </div>
      }
    </div>
  </div>
</div>
